var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('heads'),_c('div',{},[_c('router-view')],1),_c('div',[_c('dibu',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.keepAlive),expression:"$route.meta.keepAlive"}],attrs:{"color":_vm.color}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }